import { render, staticRenderFns } from "./partnerProductAccountComponent.vue?vue&type=template&id=4ca59dc8&scoped=true&"
import script from "./partnerProductAccountComponent.vue?vue&type=script&lang=js&"
export * from "./partnerProductAccountComponent.vue?vue&type=script&lang=js&"
import style0 from "./partnerProductAccountComponent.vue?vue&type=style&index=0&id=4ca59dc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca59dc8",
  null
  
)

export default component.exports